var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.2512H20.75V11.0012C20.75 8.58117 19.42 7.25116 17 7.25116H12.75V6.02116C13.33 6.16116 13.91 6.24116 14.5 6.24116C15.44 6.24116 16.38 6.06116 17.28 5.70116C17.56 5.59116 17.75 5.31117 17.75 5.00117V2.00117C17.75 1.75117 17.63 1.52117 17.42 1.38117C17.21 1.24117 16.95 1.21117 16.72 1.30117C15.29 1.87117 13.71 1.87117 12.28 1.30117C12.05 1.21117 11.79 1.24117 11.58 1.38117C11.37 1.52117 11.25 1.75117 11.25 2.00117V5.00117V7.25116H7C4.58 7.25116 3.25 8.58117 3.25 11.0012V21.2512H2C1.59 21.2512 1.25 21.5912 1.25 22.0012C1.25 22.4112 1.59 22.7512 2 22.7512H4H20H22C22.41 22.7512 22.75 22.4112 22.75 22.0012C22.75 21.5912 22.41 21.2512 22 21.2512ZM7.24 21.2512H4.75V12.7512H7.24V21.2512ZM11.24 21.2512H8.74V12.7512H11.24V21.2512ZM15.24 21.2512H12.74V12.7512H15.24V21.2512ZM19.25 21.2512H16.74V12.7512H19.25V21.2512Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.aca450c0.svg";
export { ForwardRef as ReactComponent };